/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Kbd_OpenInputs */

const en_us2_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open`)
};

const pt_br2_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abrir`)
};

const es_419_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abrir`)
};

const pt_pt2_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abrir`)
};

const fr_fr2_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ouvrir`)
};

const de_de2_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`öffnen`)
};

const it_it2_search_kbd_open = /** @type {(inputs: Search_Kbd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`apri`)
};

/**
* | output |
* | --- |
* | "open" |
*
* @param {Search_Kbd_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_kbd_open = /** @type {((inputs?: Search_Kbd_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Kbd_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_kbd_open(inputs)
	if (locale === "es-419") return es_419_search_kbd_open(inputs)
	if (locale === "pt-PT") return pt_pt2_search_kbd_open(inputs)
	if (locale === "fr-FR") return fr_fr2_search_kbd_open(inputs)
	if (locale === "de-DE") return de_de2_search_kbd_open(inputs)
	if (locale === "it-IT") return it_it2_search_kbd_open(inputs)
	return en_us2_search_kbd_open(inputs)
});
export { search_kbd_open as "search.kbd_open" }